import { useRef } from "react";
import { ImageUp, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

// Mesmo limite do servidor (Empresa.IMAGEM_MAX)
const TAMANHO_MAXIMO = 300 * 1024;

type ImagemInputProps = {
  id: string;
  label: string;
  descricao: string;
  valor?: string;
  // Prévia do padrão quando não há imagem
  padrao: React.ReactNode;
  onChange(valor?: string): void;
}

// Imagem guardada como data URL no próprio cadastro
export const ImagemInput = ({ id, label, descricao, valor, padrao, onChange }: ImagemInputProps) => {
  const arquivo = useRef<HTMLInputElement>(null);

  const escolher = (file?: File) => {
    if (!file) return;
    if (file.size > TAMANHO_MAXIMO) {
      toast.error(`${label}: a imagem deve ter no máximo 300 KB.`);
      return;
    }
    const leitor = new FileReader();
    leitor.onload = () => onChange(leitor.result as string);
    leitor.readAsDataURL(file);
  }

  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <div className="flex items-center gap-4">
        <div className="flex h-16 w-28 shrink-0 items-center justify-center rounded-lg border bg-muted/40 p-2">
          {valor ? <img src={valor} alt={`${label} atual`} className="max-h-full max-w-full object-contain" /> : padrao}
        </div>
        <div className="space-y-2">
          <p className="text-xs text-muted-foreground">{descricao}</p>
          <div className="flex flex-wrap gap-2">
            <Button type="button" variant="outline" size="sm" className="disabled:hidden" onClick={() => arquivo.current?.click()}>
              <ImageUp className="mr-2 h-4 w-4" /> {valor ? 'Trocar' : 'Escolher imagem'}
            </Button>
            {valor && (
              <Button type="button" variant="ghost" size="sm" className="disabled:hidden" onClick={() => onChange(undefined)}>
                <Trash2 className="mr-2 h-4 w-4" /> Usar o padrão
              </Button>
            )}
          </div>
        </div>
      </div>
      <input ref={arquivo} id={id} type="file" className="hidden"
        accept="image/png,image/jpeg,image/gif,image/webp,image/svg+xml,image/x-icon,image/vnd.microsoft.icon"
        onChange={e => { escolher(e.target.files?.[0]); e.target.value = ''; }} />
    </div>
  );
}
